import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useCallback, useEffect, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import TabHeader from "../common/TabHeader";
import { ListBox } from "primereact/listbox";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";

export default function DialogAssignSubjects({ visible, closeDialog, courseSubjects, setCourseSubjects, courseId, view_index }) {
    const { requestAPI, showToast } = useAppContext();

    const [availableSubjects, setAvailableSubject] = useState();
    const [selectedSubjects, setSelectedSubjects] = useState();

    const [loading, setLoading] = useState();

    useEffect(() => {
        if (!availableSubjects)
            requestAPI({
                requestPath: `subjects`,
                requestMethod: "GET",
                setLoading: setLoading,
                onResponseReceieved: (subjects, responseCode) => {
                    if (subjects && responseCode === 200) {
                        setAvailableSubject(() => subjects.filter(({ id }) => !courseSubjects?.find(({ subject_id }) => subject_id === id)));
                    } else {
                        showToast({ severity: "error", summary: "Failed", detail: "Failed To Load Subjects !", life: 2000 });
                    }
                },
            });
    }, [availableSubjects, courseId, courseSubjects, requestAPI, showToast]);

    const addSubjects = useCallback(() => {
        requestAPI({
            requestPath: `course-subjects`,
            requestMethod: "POST",
            requestPostBody: { course_id: courseId, subjects: selectedSubjects, view_index },
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Assign Subjects !", life: 2000 }),
            onResponseReceieved: (subjects, responseCode) => {
                if (subjects && responseCode === 201) {
                    showToast({ severity: "success", summary: "Assigned", detail: "Subjects Assigned", life: 1000 });
                    setCourseSubjects(() => subjects);
                    closeDialog(); //close the dialog
                } else showToast({ severity: "error", summary: "Failed", detail: "Failed To Assign Subjects !", life: 2000 });
            },
        });
    }, [closeDialog, courseId, requestAPI, selectedSubjects, setCourseSubjects, showToast, view_index]);

    return (
        <Dialog header={`Assign Subjects`} visible={visible} className="w-11" onHide={closeDialog} pt={{ content: { className: "overflow-y-auto" } }}>
            <TabHeader className="pt-3" title="Assign Existing Subject" highlights={["New Subject Can Be Mapped Here", "Subjects Can Be Unmapped From List"]} />

            <ListBox
                filter
                multiple
                value={selectedSubjects}
                onChange={(e) => setSelectedSubjects(e.value)}
                options={availableSubjects}
                className="mt-4 "
                listStyle={{ maxHeight: "250px" }}
                itemTemplate={(option) => (
                    <span className="font-semibold">
                        {option?.id}. {option?.title}
                    </span>
                )}
            />
            <HasRequiredAuthority requiredAuthority={AUTHORITIES.CREATE_COURSE_SUBJECTS}>
                <Button className="mt-3" label="Add Subjects" severity="warning" disabled={!selectedSubjects?.length} loading={loading} onClick={addSubjects} />
            </HasRequiredAuthority>
        </Dialog>
    );
}
